import ChangeTripsModalAlert from '@/components/manage/change-trips/ChangeTripsModalAlert';
import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import { inboundJourneysLoadingSelector } from '@/features/loading/loadingSelectors';
import {
  setSelectedInboundOfferMapByLegId,
  updateSelectedInboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  selectedInboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useChangeTravelClass } from '@/hooks/useChangeTravelClass';
import { useJourneyOfferContinue } from '@/hooks/useJourneyOfferContinue';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import { getDefaultOfferMap } from '@/utils/purchase';
import { getJourneyWarnings } from '@/utils/warning';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const InboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inboundData = useSelector(inboundDataSelector);
  const isLoading = useSelector(inboundJourneysLoadingSelector);
  const {
    isChangeTravelClassFlow,
    getChangeTravelClassOffers,
    handleGoBack: handleChangeTravelClassFlowGoBack,
    showStartExchangeError,
  } = useChangeTravelClass({
    isOutbound: false,
  });
  const {
    onContinue,
    changeTravelClassAlert,
    handleAlertBack,
    handleAlertContinue,
    booking,
  } = useJourneyOfferContinue({
    isOutbound: false,
    isChangeTravelClassFlow,
    getChangeTravelClassOffers,
    showStartExchangeError,
  });
  const selectedJourneyWarnings = useMemo(
    () => getJourneyWarnings(inboundData.selectedJourney, inboundData.warnings),
    [inboundData.selectedJourney, inboundData.warnings]
  );

  useEffect(() => {
    if (!inboundData.selectedJourney && !inboundData.journeys) {
      if (isChangeTravelClassFlow) {
        getChangeTravelClassOffers();
        return;
      }
      navigate('/purchase');
      return;
    }
    if (inboundData.selectedJourney) {
      dispatch(
        setSelectedInboundOfferMapByLegId(
          getDefaultOfferMap(inboundData.selectedJourney)
        )
      );
    }
  }, [
    dispatch,
    getChangeTravelClassOffers,
    isChangeTravelClassFlow,
    navigate,
    inboundData.journeys,
    inboundData.selectedJourney,
  ]);

  return (
    <>
      <ChangeTripsModalAlert
        alert={changeTravelClassAlert}
        booking={booking}
        isOpen={Boolean(changeTravelClassAlert)}
        onBack={handleAlertBack}
        onClose={handleAlertBack}
        onContinue={handleAlertContinue}
        selectedTrip={inboundData.selectedJourney}
      />
      <JourneyOfferList
        title={<TransText i18nKey="selectReturnTicket" />}
        selectedJourney={inboundData.selectedJourney}
        isOutbound={false}
        updateSelectedOfferMap={updateSelectedInboundOfferMapByLegId}
        selectedOfferMapByLegIdSelector={selectedInboundOfferMapSelector}
        isLoading={isLoading}
        warnings={selectedJourneyWarnings}
        onContinue={onContinue}
        onGoBack={
          isChangeTravelClassFlow
            ? handleChangeTravelClassFlowGoBack
            : () => navigate(-1)
        }
      />
    </>
  );
};

export default InboundJourneyOfferList;
